import { render, staticRenderFns } from "./CreateTaskModal.vue?vue&type=template&id=13486f94"
import script from "./CreateTaskModal.vue?vue&type=script&lang=ts"
export * from "./CreateTaskModal.vue?vue&type=script&lang=ts"
import style0 from "./CreateTaskModal.vue?vue&type=style&index=0&id=13486f94&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports